// removed by extract-text-webpack-plugin
module.exports = {"col":"Col__col___3cVp4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseGrid/Col/Col.scss
// module id = 1011
// module chunks = 0